import { Box, Container, Grid2, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { Profile } from './Profile';
import {
  NAVBAR_ADMIN_HEADER_PAGES,
  NAVBAR_INTERVIEWER_HEADER_PAGES,
  NAVBAR_TA_HEADER_PAGES,
  NAVBAR_USER_HEADER_PAGES,
  ROLES,
} from '../../lib/constants';
import { ModeSwitcher } from '../../components/common/ModeSwitcher';
import { useSession } from '../../auth/useSession';
import { Outlet } from 'react-router-dom';
import { useColorScheme } from '../../hooks/useColorScheme';

const NavbarHeader = () => {
  const { userRole } = useSession();
  const getPagesByRole = (role: string) => {
    switch (role) {
      case ROLES.ADMIN:
        return NAVBAR_ADMIN_HEADER_PAGES;
      case ROLES.TA:
        return NAVBAR_TA_HEADER_PAGES;
      case ROLES.INTERVIEWER:
        return NAVBAR_INTERVIEWER_HEADER_PAGES;
      case ROLES.USER:
      case ROLES.CANDIDATE:
      default:
        return NAVBAR_USER_HEADER_PAGES;
    }
  };

  const getPageRoute = (pageName: string): string => {
    const routeMap: Record<string, string> = {
      'Home': '/',
      'About': '/about',
      'Interviews': '/interviews',
      'Contests': '/contests',
      'Hackathons': '/hackathons',
      'Languages': '/languages',
      'Users': '/users',
      'Training': '/training',
    };
    return routeMap[pageName] || `/${pageName.toLowerCase()}`;
  };

  const pages = userRole ? getPagesByRole(userRole) : [];
  const { colorScheme } = useColorScheme();

  return (
    <Container
      sx={{
        paddingLeft: '0 !important',
        paddingRight: '0 !important',
        maxWidth: '100vw !important',
      }}
    >
      <Box
        className="sticky top-0 z-50 mx-0 flex w-[100%] items-center justify-between px-10 py-5 text-left font-sans text-base font-normal leading-6"
        sx={{ bgcolor: 'background.default' }}
      >
        <Typography sx={{ color: 'text.primary', textTransform: 'capitalize' }}>
          <img
            src={colorScheme === 'light' ? '/img/logocb.png' : '/img/logoc.png'}
            alt="APEX Code Platform"
            height={15}
          />
          &nbsp;&nbsp; APEX CODE PLATFORM
        </Typography>
        <div className="">
          <Grid2
            container
            spacing={2}
            justifyContent="center"
            alignItems="flex-end"
          >
            {pages.map((page) => (
              <Grid2 key={page}>
                <NavLink to={getPageRoute(page)} className="no-underline">
                  {({ isActive }) => (
                    <Typography
                      sx={{
                        color: 'text.primary',
                        textTransform: 'capitalize',
                        ...(isActive
                          ? { borderBottom: '1px solid', fontWeight: 'bold' }
                          : {}),
                      }}
                    >
                      {page}
                    </Typography>
                  )}
                </NavLink>
              </Grid2>
            ))}
          </Grid2>
        </div>
        <div className="flex flex-row justify-stretch">
          <Profile />
          <ModeSwitcher />
        </div>
      </Box>
      <Outlet />
    </Container>
  );
};

export default NavbarHeader;
